// components
import { NavLink } from 'react-router-dom';
import NavMenu from '../components/NavMenu';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Image from 'react-cool-img';
import coverImage from '../assets/cover-1.jpg';
import gridImage1 from '../assets/cover-2.jpg';
import gridImage2 from '../assets/cover-3.jpg';
import gridImage3 from '../assets/cover-4.jpg';
import Footer from '../components/ui/Footer';
import styles from './homeStyles';
import { useState } from 'react';

const gridItemText = (text: string, route: string) => (
  <NavLink to={route} style={{ textDecoration: 'none' }}>
    <Box sx={styles.gridTextContainer}>
      <Typography sx={styles.gridText}>Discover more</Typography>
      <Typography
        sx={{
          ...styles.gridText,
          ...styles.gridTextDescription,
        }}
      >
        {text}
      </Typography>
    </Box>
  </NavLink>
);

const Home = () => {
  const [runAnimation, setRunAnimation] = useState(false);

  return (
    <>
      <Stack direction="column" height="100%" maxHeight="100vh">
        <NavMenu />
        <Box sx={styles.container}>
          <Image
            src={coverImage}
            alt="cover"
            style={{
              ...styles.grid,
              ...styles.coverImage,
              animationPlayState: runAnimation ? 'running' : 'paused',
            }}
            onLoad={(event: React.SyntheticEvent | Event) => {
              setRunAnimation(true);
            }}
          />
          <Box sx={styles.titleContainer}>
            <Typography variant="h1" sx={styles.title}>
              FALL
            </Typography>
            <Typography
              variant="h2"
              sx={{ ...styles.title, ...styles.flexEnd }}
            >
              COLLECTION
            </Typography>
          </Box>
          <NavLink to="/collections">
            <Typography variant="h4" sx={styles.discoverLink}>
              Discover
            </Typography>
          </NavLink>
        </Box>
      </Stack>
      <Grid container maxWidth={'100vw'}>
        <Grid item xs={12} sm={4}>
          <Box sx={styles.gridItemContainer}>
            <Image src={gridImage1} alt="grid-1" style={styles.grid} />
            {gridItemText('SS 2022 Fall Collection', '/collections')}
          </Box>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Box sx={styles.gridItemContainer}>
            <Image src={gridImage2} alt="grid-2" style={styles.grid} />
            {gridItemText('SS 2022 Menswear', '/men')}
          </Box>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Box sx={styles.gridItemContainer}>
            <Image src={gridImage3} alt="grid-3" style={styles.grid} />
            {gridItemText('SS 2022 Womenswear', '/women')}
          </Box>
        </Grid>
      </Grid>
      <Footer />
    </>
  );
};

export default Home;
